import { smoothScroll } from '../../js/common/smoothScroll';

const Main = {
  dom: null,
  now: new Date(),
  init() {
    this.dom = {
      anchors: document.querySelectorAll('a[href^="#"]:not(.js-custom-tab):not([href="#"])'),
      modals: document.querySelectorAll('.js-modal'),
      modalTriggers: document.querySelectorAll('[data-modal-trigger]'),
      modalCloseBtns: document.querySelectorAll('.js-modal-close'),
      closeMessageBtn: document.querySelector('.js-email-check-close'),
      messageDiv: document.querySelector('.js-email-check'),
    };
    this.addListeners();
    if (backEndVars.discountData && backEndVars.discountData.pageIsDiscount) {
      this.setDiscountExpiration();
    }
  },
  addListeners() {
    this.dom.anchors.forEach(a => a.addEventListener('click', this.smoothScroll.bind(this)));
    this.dom.modalTriggers.forEach(mt => mt.addEventListener('click', this.openModal.bind(this)));
    this.dom.modalCloseBtns.forEach(mcb => mcb.addEventListener('click', this.closeModals.bind(this)));
    if (this.dom.closeMessageBtn) {
      this.dom.closeMessageBtn.addEventListener('click', this.closeMessageDiv.bind(this));
    }
  },
  smoothScroll(e) {
    e.preventDefault();
    const targetElement = document.querySelector(e.currentTarget.getAttribute('href'));
    const targetOffsetTop = targetElement.offsetTop;

    smoothScroll(targetOffsetTop, 1500);
  },
  openModal(e) {
    const modal = this.getCurrentModal(e);
    let opacity = 0;
    let fadeInStep = 0.1;
    modal.style.opacity = opacity;
    modal.classList.remove('hidden');
    const timer = setInterval(function () {
      if (opacity >= 1) {
        clearInterval(timer);
      }
      opacity += fadeInStep;
      modal.style.opacity = opacity;
    }, 20);
  },
  closeModals(e) {
    e.stopPropagation();
    e.preventDefault();
    this.dom.modals.forEach(m => m.classList.add('hidden'));
  },
  getCurrentModal(e) {
    const modalId = e.currentTarget.getAttribute('data-modal-trigger');
    const selector = `[data-modal="${modalId}"]`;
    return document.querySelector(selector);
  },
  closeMessageDiv() {
    this.dom.messageDiv.style.display = 'none';
  },
  setDiscountExpiration() {
    let promoTime;
    const expirationTime = 905000;
    const key = 'discountExpiration';

    if (!store.get(key)) {
      store.set(key, this.now.getTime() + expirationTime);
    }

    promoTime = store.get(key);

    setTimeout(function () {
      store.remove(key);
      location.reload();
    }, promoTime - this.now.getTime());
  },
};

export default Main;

document.addEventListener('DOMContentLoaded', () => {
  Main.init();
});
